import { IonCardContent, IonToast, IonActionSheet, IonImg, IonFab, IonFabButton, IonLoading, IonText, IonGrid, IonRow, IonCol, IonAvatar, IonNote, IonModal, useIonViewWillLeave, IonSpinner, IonIcon, useIonRouter, useIonViewWillEnter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState, useRef } from "react";
import { logoFacebook, logoGoogle, close, ellipsisVertical, alertCircleOutline, shareSocialOutline, arrowRedoOutline, heart, wallet, closeOutline, pricetagsOutline, arrowBackOutline, chatboxEllipsesOutline, expand } from 'ionicons/icons';
import { Dialog, ConfirmResult } from '@capacitor/dialog';
import { RouteComponentProps } from "react-router-dom";
import { Share } from '@capacitor/share';


import { LANGUAGE, GetStr, LoadLanguage, GetLanguage } from "../language/Language";
import { hideTab, showTab } from "../components/Tabs";
import Vault from '../components/Vault';
import NServer, { RegisterAppServices, handleRouteError } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import { GameInfo } from "../data/game_info";
import ChatDialog from "../components/ChatDialog";
import PassCheckCtrl, { checkPasscode } from '../components/PassCheckCtrl';

import './Main.css'; 

export interface GamePageProp extends RouteComponentProps<{
    id : any,
    p1 : string,
    p2 : string
    }> 
{}

var counter = 0;
var chat_show = false;
var refreshTimer : any;

const GamePage : React.FC<GamePageProp> = ({match}) => {

    const [url, setURL] = useState("");
    const [avatar, setAvatar] = useState("/assets/img/content_pic.png");
    const [title, setTitle] = useState("");
    const [param, setParam] = useState("");
    const iFrame = useRef<any>(null);
    const [gameInfo, setGameInfo] = useState<GameInfo>();
    const [showChat, setShowChat] = useState(false);
    const [chatThread, setChatThread] = useState(-1);
    const [mainThread, setMainThread] = useState(-1);
    const [timer, setTimer] = useState(0);

    const [showBuy, setShowBuy] = useState(false);
    const [buyUI, setBuyUI] = useState(0);
    const [itemID, setItemID] = useState("");
    const [itemIcon, setItemIcon] = useState("/assets/img/apple_pic.png");
    const [itemName, setItemName] = useState("");
    const [itemDesc, setItemDesc] = useState("");
    const [itemPrice, setItemPrice] = useState(0);
    const [buyCallback, setBuyCallback] = useState("");
    const [buyType, setBuyType] = useState("USD");

    const [usd, setUSD] = useState("");
    const [nToken, setNToken] = useState("");
    const [passKey, setPassKey] = useState("-- -- --");
    const [showLoading, setShowLoading] = useState(false);

    const [sharePostID, setSharePostID] = useState(-1);
    const [showShare, setShowShare] = useState(false);
    const [shareImg, setShareImg] = useState("");
    const [shareTitle, setShareTitle] = useState("");
    const [shareDesc, setShareDesc] = useState("");

    const [fullscreen, setFullscreen] = useState(false);
    const [menu, showMenu] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMsg, setToastMsg] = useState("");
    const [userLogin, setUserLogin] = useState(false);

    const router = useIonRouter();

    useIonViewWillEnter(() => {
        RegisterAppServices();
        hideTab();

        checkUserLogin();

        counter = 0;
        chat_show = false;

        window.addEventListener('message', handleIframeTask);

        // refresh in next 5 secs
        refreshTimer = setInterval(() => {
            if (chat_show)
            {
                updateChat();
            }
        }, 5000);

        // load from server
        loadGameInfo();
    });

    useIonViewWillLeave(() => {
        showTab();
        clearInterval(refreshTimer);
    });

    // check the user login
    const checkUserLogin = async () => {
        let v = new Vault();
        await v.read();
        
        if (v.account.id > 0)
            setUserLogin(true);
        else
            setUserLogin(false);
    }

    const numberWithCommas = (x : string) => {
        return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const loadGameInfo = async () => {
        
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            game: match.params.id
        }

        var server = new NServer();
        await server.getList("get_game_info", state);

        if (!server.success && server.message != "")
        {
            showAlert(server.message);

            handleRouteError(router, server.data);
        }
        else
        {
            // update the UI
            setGameInfo(server.data.game);
            setURL(server.data.game.weblink);
            setTitle(server.data.game.caption);
            setAvatar(server.data.game.icon);
            setMainThread(server.data.main_thread);

            buildUserParams();
        }
	}

    // build the user parameters and encrypted them
    const buildUserParams = async () => {
        let v = new Vault();
        await v.read();

        // build params
        let p1 = "";
        let p2 = "";
        if (match.params.p1 != "n")
            p1 = match.params.p1;
        if (match.params.p2 != "n")
            p2 = match.params.p2;

        let lang = GetLanguage();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            p1 : p1,
            p2 : p2,
            lang: lang
        }

        var server = new NServer();
        let data = encodeURIComponent(server.encrypt(state));
        setParam(data);
    }

    // handle the iframe tasks
    const handleIframeTask = async (e : any) => {
        try {
            let obj = JSON.parse(e.data);
            if (obj != null)
            {
                // check whether object has task
                if (obj.hasOwnProperty("task"))
                {
                    let task = obj.task;
                    switch (task)
                    {
                        case "BUY":
                            showBuyTask(obj);
                            break;
                        case "CHAT":
                            showChatTask(obj);
                            break;
                        case "PM":
                            sendPrivateMsg(obj);
                            break;
                        case "POST":
                            showShareTask(obj);
                            break;
                        case "LOGIN":
                            doLogin(obj);
                            break;
                        case "TOAST":
                            doToast(obj);
                            break;
                        case "MSG":
                            // for testing
                            let accept : ConfirmResult = await showConfirm("Test", "Will you accept or not");
                            if (accept.value)
                                sendMessage('{ "task": "yes" }');
                            else
                                sendMessage('{ "task": "no" }');
                            break;
                    }
                }
            }
        }
        catch (err) {
            // skip
        }
    }

    // show the chat message
    const showChatTask = async (obj : any) => {
        if (!obj.hasOwnProperty("id"))
            return;

        let v = new Vault();
        await v.read();
        
        // retrieve chat thread from server
        let id = obj.id;
        const state = {
            id: v.account.id,
            pass: v.account.key,
            game: match.params.id,
            chat: id
        }

		var server = new NServer();
        await server.getList("nc_app_chat", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // update the UI
            let thread = server.data.thread;

            if (thread > 0)
            {
                setChatThread(thread);
                showChatDialog(true);
            }
        }
    }

    // send privare msg
    const sendPrivateMsg = async (obj : any) => {
        if (!obj.hasOwnProperty("user"))
            return;

        let v = new Vault();
        await v.read();
        
        // retrieve chat thread from server
        let user = obj.user;
        const state = {
            id: v.account.id,
            pass: v.account.key,
            game: match.params.id,
            user: user
        }

		var server = new NServer();
        await server.getList("nc_app_pm", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            // update the UI
            let thread = server.data.thread;

            if (thread > 0)
            {
                setChatThread(thread);
                showChatDialog(true);
            }
        }
    }

    // show the buy dialog box
    const showBuyTask = (obj : any) => {
        let id = "";
        let name = "";
        let price = 0;
        let desc = "";
        let icon = "/assets/img/apple_pic.png";
        let buy_type = "USD";
        let callback = "";

        // retrieve data
        if (obj.hasOwnProperty("id"))
            id = obj.id;
        if (obj.hasOwnProperty("name"))
            name = obj.name;
        if (obj.hasOwnProperty("price"))
            price = obj.price;
        if (obj.hasOwnProperty("desc"))
            desc = obj.desc;
        if (obj.hasOwnProperty("icon"))
            icon = obj.icon;
        if (obj.hasOwnProperty("type"))
            buy_type = obj.type;
        if (obj.hasOwnProperty("callback"))
            callback = obj.callback;

        // set data
        setItemID(id);
        setItemName(name);
        setItemPrice(price);
        setItemDesc(desc);
        setItemIcon(icon);
        setBuyType(buy_type);
        setBuyCallback(callback);

        setBuyUI(0);  // first page
        setShowBuy(true);
        // retrieve user wallet
        retrieveUserWallet();
    }

    // show the sharing dialog box
    const showShareTask = async (obj : any) => {
        let title = "";
        let desc = "";
        let img_id = 0;
        let variables = "";
        let template = "";

        // retrieve data
        if (obj.hasOwnProperty("id"))
            img_id = obj.id;
        if (obj.hasOwnProperty("title"))
            title = obj.title;
        if (obj.hasOwnProperty("desc"))
            desc = obj.desc;
        if (obj.hasOwnProperty("vars"))
            variables = obj.vars;
        if (obj.hasOwnProperty("template"))
            template = obj.template;

        // ask the server to generate a new post for this
        let v = new Vault();
        await v.read();
        
        // retrieve chat thread from server
        let user = obj.user;
        const state = {
            id: v.account.id,
            pass: v.account.key,
            game: match.params.id,
            title: title,
            desc: desc,
            img_id: img_id,
            temp: template,
            vars: variables
        }

		var server = new NServer();
        await server.sendForm("nc_app_get_post", state);

        // set data
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            console.log("Err: " + server.message);
        }
        else
        {
            setSharePostID(server.data.post);
            setShareTitle(server.data.title);
            setShareImg(server.data.image);
            setShareDesc(server.data.desc);
        
            setShowShare(true);
        }
    }

    // send message to iframe
    const sendMessage = (data : any) => {
        if (!iFrame)
            return;
        if (!iFrame.current)
            return;
        
        iFrame.current.contentWindow.postMessage(data, "*");
    }

    // send message to iframe
    const doLogin = async (data : any) => {
        let v = new Vault();
        await v.read();
        
        if (v.account.id < 20)
        {
            // close all UI
            setShowChat(false);
            setShowShare(false);
            setShowBuy(false);

            router.push("/login", "back", "pop");
        }
        else
        {
            setToastMsg(GetStr(LANGUAGE.TXT_ALREADY_LOGIN));
            setShowToast(true);
        }
    }

    const doToast = (data : any) => {
        let msg = "";
        // retrieve data
        if (data.hasOwnProperty("msg"))
            msg = data.msg; 

        if (msg != "")
        {
            setToastMsg(msg);
            setShowToast(true);
        }
    }

    const closeUI = () => {
        router.push("/token/games", "back", "pop");
    }

    // go full screen
    const goFullscreen = () => {
        //DEL sendMessage('{ "task": "FS" }');
        setFullscreen(true);
    }

    // go window mode
    const goWindowMode = () => {
        //DEL sendMessage('{ "task": "FS" }');
        setFullscreen(false);
    }

    // go to public chat
    const publicChat = () => {
        if (mainThread >= 0)
        {
            setChatThread(mainThread);
            showChatDialog(true);
            
        }
    }

    // retrieve user wallet
    const retrieveUserWallet = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key
        }

		var server = new NServer();
        await server.getList("nc_wallet", state);

        if (!server.success && server.message != "")
        {
            setUSD("---");
            setNToken("---");
        }
        else
        {
            setUSD(server.data.usd);
            setNToken(server.data.ntoken);
        }
    }

    // biometric payment
    const biometricSubmit = async (username : string, password : string) => {
        await submitMoney(password);
    }

    // manual payment
    const send = async () => {
        await submitMoney(passKey);
    }

    const submitMoney = async (pass : string) => {
        
        setShowLoading(true);

        let v = new Vault();
        await v.read();
        
        // retrieve chat thread from server
        const state = {
            id: v.account.id,
            pass: v.account.key,
            game: match.params.id,
            ptype: buyType,
            amount: itemPrice,
            item: itemID,
            lock: passKey,
            callback: encodeURIComponent(buyCallback)
        }

		var server = new NServer();
        await server.sendForm("nc_app_buy", state);

        if (!server.success && server.message != "")
        {
            console.log(server.message);
            showAlert(server.message);
        }
        else
        {
            // send msg to client
            //DEL sendMessage('{ "task": "BUY-SUS", "id": "' + itemID + '" }');

            // success
            setBuyUI(2);
        }
        
        setShowLoading(false);        
    }

    // updare the chat message
    const updateChat = () => {
        counter += 1;
        setTimer(counter);
    }

    // show the chat dialogbox
    const showChatDialog = (show : boolean) => {
        chat_show = show;
        setShowChat(show);
    }

    // do a share post
    const doSharePost = async () => {
        setShowLoading(true);

        let v = new Vault();
        await v.read();
        
        // retrieve chat thread from server
        const state = {
            id: v.account.id,
            pass: v.account.key,
            game: match.params.id,
            img: shareImg,
            title: shareTitle,
            desc: shareDesc
        }

		var server = new NServer();
        await server.sendForm("nc_app_post", state);

        if (!server.success && server.message != "")
        {
            showAlert(server.message);
            console.log(server.message);
        }
        else
        {
            // success
            setShowShare(false);
        }
        
        setShowLoading(false);        
    }
    
    // share the game
    const shareGame = async () => {
        let link = "https://nwallet.me/d/social.php?r=gg" + match.params.id + "/n/n";

        await Share.share({
            title: title,
            text: "Check this out!",
            url: link,
            dialogTitle: "Share Post"
        });

        showMenu(false);
    }

    // report this to admin
    const reportAdmin = () => {
        showMenu(false);
        router.push("/report/" + match.params.id + "/game", "forward", "push");
    }

    // buy passkey
    const buyPassKey = async () => {
        // check whether passcode is set or not
        let pass = await checkPasscode(router);

        if (pass)
        {
            // #1 is passkey
            setBuyUI(1);
        }
        else
        {
            setShowBuy(false);
        }
    }

    // share to facebook
    const shareOutside = async () => {
        if (sharePostID <= 0)
            return;

        let link = "https://nwallet.me/d/social.php?r=gp" + sharePostID;

        await Share.share({
            title: shareTitle,
            text: shareDesc,
            url: link,
            dialogTitle: "Share Post"
        });
    }

    return (
        <IonPage>
            {
                !fullscreen ?
            <IonHeader translucent className="ion-no-border">   
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton onClick={closeUI}><IonIcon icon={arrowBackOutline} /></IonButton>
                    </IonButtons>
                    <IonItem className="chat-header" lines="none" color="none">
                        <IonAvatar slot="start">
                            <img src={avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/content_pic.jpg' } } />
                        </IonAvatar>
                        <IonLabel>
                            { title }
                        </IonLabel>
                    </IonItem>
                    <IonButtons slot="end">
                        <IonButton onClick={publicChat}><IonIcon slot="icon-only" icon={chatboxEllipsesOutline}></IonIcon></IonButton>
                        <IonButton onClick={goFullscreen}><IonIcon slot="icon-only" icon={expand}></IonIcon></IonButton>
                        <IonButton onClick={()=>showMenu(true)}><IonIcon slot="icon-only" icon={ellipsisVertical} /></IonButton>
                    </IonButtons>
                </IonToolbar>

                { /* menu */ }
                <IonActionSheet
                    isOpen={menu}
                    onDidDismiss={() => showMenu(false)}
                    buttons={
                        [
                        {
                            text: GetStr(LANGUAGE.TXT_SHARE_POST),
                            icon: shareSocialOutline,
                            handler: shareGame
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_REPORT_ADMIN),
                            icon: alertCircleOutline,
                            handler: reportAdmin
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_CANCEL),
                            icon: close,
                            role: 'cancel',
                            handler: () => { showMenu(false) }
                        } 
                        ]
                    }
                    >
                </IonActionSheet>
            </IonHeader>
                :
            <IonFab slot="fixed" vertical="top" horizontal="end">
                <IonFabButton className="close-but-float" color="light" onClick={goWindowMode}>
                    <IonIcon icon={closeOutline}></IonIcon>
                </IonFabButton>
            </IonFab>
            }
            <IonContent>
                {
                    param == "" || url == "" ?
                <div className="spinnerCenter">
                    <IonSpinner name="crescent" />
                </div>
                    :
                <iframe ref={iFrame} className="game-page" name="gamepage" src={ url + "?d=" + param } frameBorder="0">
                </iframe>
                }
            </IonContent>

            <IonLoading
                isOpen={showLoading}
                onDidDismiss={() => setShowLoading(false)}
                message={ GetStr(LANGUAGE.TXT_PLZ_WAIT) }
            />

            <ChatDialog
                show={showChat}
                dismiss={ ()=> showChatDialog(false) }
                thread={chatThread}
                timer={timer}
                updateChat={updateChat}
            />

            <IonToast
                isOpen={showToast}
                onDidDismiss={() => setShowToast(false)}
                message={ toastMsg }
                position="bottom"
                duration={5000}
                buttons={[
                  {
                    text: 'X',
                    role: 'cancel',
                    handler: () => {
                        setShowToast(false);
                    }
                  }
                ]}
            />

            { /* payment dialog */ }
            <IonModal
                isOpen={showBuy}
                initialBreakpoint={ 0.7 }
                onDidDismiss={ ()=> setShowBuy(false) }
            >
                <div className="ion-page">
                    <IonToolbar id="modal">
                        <IonItem lines="none">
                            <IonIcon icon={pricetagsOutline} slot="start" />
                            <IonLabel>
                                { GetStr(LANGUAGE.TXT_GP_PAYMENT_CAP) }
                            </IonLabel>
                        </IonItem>
                        <IonButtons slot="end">
                            <IonButton onClick={ ()=> setShowBuy(false) }>
                                <IonIcon icon={closeOutline} size="large"/>
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                    <IonContent>
                        <IonGrid className="ion-no-padding tab-content game-ui">
                            <IonRow className="full-content">
                                <IonCol>
                                    {
                                        !userLogin ?
                                    <div>
                                        <IonCard className="flat-card">
                                            <IonCardContent>
                                                <div><IonImg className="info-pic" src="/assets/img/forget_pass_pic.png" /></div>
                                                <div>{ GetStr(LANGUAGE.TXT_NEED_LOGIN) }</div>
                                            </IonCardContent>
                                            <IonButton className="main-but ion-margin" expand="block" onClick={ doLogin }>
                                                <IonIcon slot="start" icon={logoGoogle} />
                                                { GetStr(LANGUAGE.TXT_GOOGLE_LOGIN) }
                                            </IonButton>
                                        </IonCard>
                                    </div>
                                        :
                                        buyUI == 0 ?
                                    <div>
                                        { /* item price and description */ }
                                        <IonCard className="flat-card">
                                            <IonItem class="align-items-start" lines="none">
                                                <IonAvatar className="item-icon-top" slot="start">
                                                    <img src={itemIcon} onError={ ({currentTarget}) => { currentTarget.src = "/assets/img/apple_pic.png" } } />
                                                </IonAvatar>
                                                <IonLabel className="ion-text-wrap">
                                                    <h2>{itemName}</h2>
                                                    <h1 className="gp-price-tag"><small>{ GetStr(LANGUAGE.GP_PRICE) }</small>{buyType} {numberWithCommas("" + itemPrice)}</h1>
                                                    <IonNote>{itemDesc}</IonNote>
                                                </IonLabel>
                                            </IonItem>
                                        </IonCard>
                                        { /* available money */ }
                                        <IonCard className="flat-card">
                                            <IonItem lines="none">
                                                <IonIcon icon={wallet} slot="start" color="primary" />
                                                <IonText>{ GetStr(LANGUAGE.TXT_USD_CAP) }</IonText>
                                                {
                                                    usd != "" ?
                                                <IonText slot="end"><b>${ numberWithCommas(usd) }</b></IonText>
                                                    :
                                                <IonSpinner name="crescent" slot="end"></IonSpinner>
                                                }
                                            </IonItem>
                                    
                                            <IonItem lines="full">
                                                <IonIcon icon={heart} slot="start" color="primary" />
                                                <IonText>{ GetStr(LANGUAGE.TXT_NTOKEN_CAP) }</IonText>
                                                {
                                                    nToken != "" ?
                                                <IonText slot="end"><b>{ numberWithCommas(nToken) }</b></IonText>
                                                    :
                                                <IonSpinner name="crescent" slot="end"></IonSpinner>
                                                }
                                            </IonItem>
                                        </IonCard>
                                        <div className="ion-padding-top">
                                            <IonButton className="main-but ion-margin" expand="block" onClick={buyPassKey}>
                                                { GetStr(LANGUAGE.TXT_GP_MAKE_PAY) }
                                            </IonButton>
                                            <IonButton className="main-but ion-margin" expand="block" color="secondary" onClick={ ()=> setShowBuy(false) }>
                                                { GetStr(LANGUAGE.TXT_GP_PAY_CLOSE) }
                                            </IonButton>
                                        </div>
                                    </div>
                                        :
                                        buyUI == 1 ?
                                    <div>
                                        <PassCheckCtrl onChange={setPassKey} onSubmit={send} onBiometric={biometricSubmit} />
                                    </div>
                                        :
                                        buyUI == 2 ?
                                    <div>
                                        <h4 className="ion-padding-bottom ion-text-center">
                                            { GetStr(LANGUAGE.TXT_GP_PAY_SUCCESSFUL) }
                                        </h4>
                                        { /* item price and description */ }
                                        <IonCard className="flat-card">
                                            <IonItem class="align-items-start" lines="none">
                                                <IonAvatar className="item-icon-top" slot="start">
                                                    <img src={itemIcon} onError={ ({currentTarget}) => { currentTarget.src = "/assets/img/apple_pic.png" } } />
                                                </IonAvatar>
                                                <IonLabel className="ion-text-wrap">
                                                    <h2>{itemName}</h2>
                                                    <h1 className="gp-price-tag"><small>{ GetStr(LANGUAGE.GP_PRICE) }</small>{buyType} {numberWithCommas("" + itemPrice)}</h1>
                                                    <IonNote>{itemDesc}</IonNote>
                                                </IonLabel>
                                            </IonItem>
                                        </IonCard>
                                        
                                        <div className="ion-padding-top">
                                            <IonButton className="main-but ion-margin" expand="block" color="secondary" onClick={ ()=> setShowBuy(false) }>
                                                { GetStr(LANGUAGE.TXT_GP_PAY_CLOSE) }
                                            </IonButton>
                                        </div>
                                    </div>
                                        :
                                    <div/>
                                    }
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonContent>
                </div>
            </IonModal>

            { /* sharing dialog */ }
            <IonModal
                isOpen={showShare}
                initialBreakpoint={ 0.9 }
                onDidDismiss={ ()=> setShowShare(false) }
            >
                <div className="ion-page">
                    <IonToolbar id="modal">
                        <IonItem lines="none">
                            <IonIcon icon={arrowRedoOutline} slot="start" />
                            <IonLabel>
                                { GetStr(LANGUAGE.TXT_GP_SHARE_CAP) }
                            </IonLabel>
                        </IonItem>
                        <IonButtons slot="end">
                            <IonButton onClick={ ()=> setShowShare(false) }>
                                <IonIcon icon={closeOutline} size="large"/>
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                    <IonContent>
                        <IonGrid className="ion-no-padding tab-content game-ui">
                            <IonRow className="full-content">
                                <IonCol>
                                    {
                                        shareImg != "" ?
                                    <img className="image-thumbnail" src={shareImg}  onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/con_err.jpg' } } />
                                        :
                                    <div/>
                                    }
                                    <IonItem lines="none">
                                        <IonLabel className="ion-text-wrap">
                                    {
                                        shareTitle != "" ?
                                    <IonText className="content-title">{shareTitle}<br/></IonText>
                                        :
                                    <div/>
                                    }

                                    {
                                        shareDesc != "" ?
                                    <IonText className="content-desc">{shareDesc}</IonText>
                                        :
                                    <div/>
                                    }
                                        </IonLabel>
                                    </IonItem>
                                    <div className="ion-padding-top">
                                        {
                                            userLogin ?
                                            <IonButton className="main-but ion-margin" expand="block" onClick={ doSharePost }>
                                                { GetStr(LANGUAGE.TXT_GP_SHARE_BUT) }
                                            </IonButton>
                                            :
                                        <IonButton className="main-but ion-margin" expand="block" onClick={ doLogin }>
                                            <IonIcon slot="start" icon={logoGoogle} />
                                            { GetStr(LANGUAGE.TXT_GOOGLE_LOGIN) }
                                        </IonButton>
                                        }
                                        <IonButton className="main-but ion-margin" expand="block" color="secondary" onClick={ shareOutside }>
                                            <IonIcon slot="start" icon={logoFacebook} />
                                            { GetStr(LANGUAGE.TXT_SHARE_POST) }
                                        </IonButton>
                                    </div>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonContent>
                </div>
            </IonModal>
        </IonPage>
    );
};

export default GamePage;